/** Совпадает с regexp в AuthRegisterRequest / UpdateMyProfileRequest на бэкенде. */
const EMAIL_RE = /^.+@.+\..+$/;
export function isValidEmail(value) {
    const trimmed = value.trim();
    return trimmed.length > 0 && EMAIL_RE.test(trimmed);
}
